import { InferGetStaticPropsType, GetStaticProps, GetStaticPaths } from 'next'

import { NewsArticle } from '@components/NewsArticle'
import { getNews, getAllNews } from '@lib/api/news'
import { NewsPostSkeleton } from '@lib/api/types'
import { CustomHead } from '@ui/sections/CustomHead'

function NewsPage({ news }: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <>
      <CustomHead
        title={news.opengraphTitle}
        description={news.opengraphDescription}
        imagePath={
          news.opengraphImage
            ? `https:${news.opengraphImage.fields.file.url}`
            : ''
        }
      />
      <NewsArticle news={news} />
    </>
  )
}

export const getStaticProps: GetStaticProps<
  {
    news: NewsPostSkeleton
  },
  { slug: string }
> = async context => {
  if (!context.params) {
    return {
      notFound: true,
    }
  }

  const { slug } = context.params

  const news = await getNews(slug)

  if (!news) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      news,
    },
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const news = await getAllNews()
  const paths = news.map(({ slug }) => ({ params: { slug } }))
  return {
    paths,
    fallback: 'blocking',
  }
}

export default NewsPage
